require('./loanRepaymentPlanFiltersHeader.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
// @ components
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
// @ utilities
const { recordLinkV2 } = require('utilities/tagging');
// @ helpers
const { formatText } = require('core/i18n').i18n;
// @ constants
const { DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
// @analytics
const { commonCatalogueFilters, commonFilterAnalyticsId } = require('utilities/taggingCommonCatalogue');

class LoanRepaymentPlanFiltersHeader extends React.Component {

    buildFilterDateLabel() {
        const { immFilter, onClearFilters } = this.props;
        const immFilterDate = immFilter.get('date');

        if (immFilter.get('isActive')) {
            const labelFromDate = immFilterDate.get('from').locale(DATE_PICKER_CUSTOM_LOCALE).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
            const labelToDate = immFilterDate.get('to').locale(DATE_PICKER_CUSTOM_LOCALE).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

            return (
                <LabelFilterRange
                    key="filter-date"
                    from={labelFromDate}
                    to={labelToDate}
                    closeCallback={() => {
                        recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.RESET_FILTER]());
                        onClearFilters()
                    }} // Because there is only one filter to clear
                />
            );
        }
    }

    render() {
        const dateLabel = this.buildFilterDateLabel();

        return (
            <header className="loan-repayment-plan-filters-header">
                <div className="loan-repayment-plan-filters-header__labels">
                    {dateLabel}
                </div>
            </header>
        );
    }
}

LoanRepaymentPlanFiltersHeader.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onClearFilters: PropTypes.func.isRequired
};

module.exports = LoanRepaymentPlanFiltersHeader;
